import CustomStyle from '@/components/Common/CustomStyle';

export default {
  name: 'ConfirmMessageChangePassword',

  components: { CustomStyle },

  props: [],

  data() {
    return {};
  },

  computed: {
    additionalStyles() {
      return this.$store.getters['global/brandTheme'].additionalStyles;
    },
  },

  methods: {},
};



// WEBPACK FOOTER //
// ./src/components/AuthLoginRegisterPage/ConfirmMessageChangePassword/component.js